export const LANGUAGE_PREFERENCE_KEY = "classroom-interface-language-v1";
export type InterfaceLanguage = "zh-HK" | "en";

export function isInterfaceLanguage(value: unknown): value is InterfaceLanguage {
  return value === "zh-HK" || value === "en";
}

export function savedInterfaceLanguage(): InterfaceLanguage {
  try {
    const value = localStorage.getItem(LANGUAGE_PREFERENCE_KEY);
    return isInterfaceLanguage(value) ? value : "zh-HK";
  } catch {
    return "zh-HK";
  }
}

export function rememberInterfaceLanguage(language: InterfaceLanguage) {
  try {
    localStorage.setItem(LANGUAGE_PREFERENCE_KEY, language);
  } catch {
    // A blocked preference store must not prevent changing the current interface.
  }
}
